<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="orderId_list" class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Order Id</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"> </v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Order Id</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.orderId_no" label="Order Id"
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12">
                                                    <v-autocomplete v-model="editedItem.academic_year"
                                                        label="Academic Year" :items="academic_year_list" item-text="ay"
                                                        item-value="id" :disabled="editedIndex != -1" persistent-hint
                                                        :hint="editedIndex == -1
                                                            ? 'Select Academic Year'
                                                            : 'noneditable'
                                                            " :filled="editedIndex == -1 ? false : true"
                                                        :error="errorMsg.academic_year ? true : false" :error-messages="errorMsg.academic_year ? 'Required' : ''
                                                            " :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>




            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {

    components: {
        Breadcrumbs,
    },

    data: () => ({
        valid: false,

        // country_super_master_list_nationality: '',
        overlay: false,
        errorMsg: {
            academic_year: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,

        // extraBreadcrumbItems: [
        //     { text: "Order Id", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style1",

        headers: [
            {
                text: "Order Id",
                align: "left",
                sortable: false,
                value: "orderId_no",
            },

            {
                text: "Academic Year",
                align: "left",
                sortable: false,
                value: "academicyear_name",
            },

        ],

        orderId_list: [],
        academic_year_list: [],
        editedIndex: -1,
        addedItem: {
            orderId_list: "",
            //country_super_master_list_nationality: '',
        },
        editedItem: {

            orderId_id: "",
            orderId_no: "",

            academic_year: "",



        },
        defaultItem: {
            orderId_id: "",
            orderId_no: "",

            academic_year: "",

        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Order Id" : "Edit Order Id";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },

    // created () {
    //   this.initialize()
    // },
    mounted() {
        this.onLoad();
    },
    methods: {
        editItem(item) {
            this.editedIndex = this.orderId_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/AccountingAndFees/getorderId")
                .then((res) => {
                    if (res.data.msg == "200") {
                        //window.alert(res.data.msg)

                        if ((this.load = true)) {
                            this.overlay = false;
                            this.orderId_list = res.data.orderId_list;
                            this.academic_year_list = res.data.ay_list;
                        }
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        // deleteItem (item) {
        //   const index = this.country_master_list.indexOf(item)
        //   confirm('Are you sure you want to delete this item?') && this.country_master_list.splice(index, 1)
        // },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/AccountingAndFees/editorderId", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                //window.alert(res.data.msg)
                                Object.assign(this.orderId_list[this.editedIndex], this.editedItem);
                            }
                            this.showSnackbar("#4caf50", "orderId Updated Successfully..."); // show snackbar on success
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {

                axios
                    .post("/AccountingAndFees/saveorderId", this.editedItem)
                    .then((res) => {
                        if (res.data.status.code == "SUCCESS") {

                            this.orderId_list.push(this.addedItem);
                            this.showSnackbar("#4caf50", "orderId Added Successfully!!!"); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.status.code == "NA") {

                            this.showSnackbar("#b71c1c", "orderId Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        }, //save()
        isValidated() {
            if (this.editedItem.academic_year) {
                return true;
            } else {
                if (!this.editedItem.academic_year) {
                    this.errorMsg.academic_year = true;
                }

                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
